<template>
  <OrModalV3
    :is-open="isOpen"
    size="m"
    data-test="queue-info-modal"
    @close="$emit('close')"
  >
    <queue-info-form
      :queue-attributes="queueAttributes"
      :is-loading="isLoading"
    />
    <template #header>
      {{ $t('infoModal.generalInformation') }}
    </template>
    <template #footer>
      <div
        class="flex items-center justify-end gap-[16px]"
      >
        <OrButtonV3
          variant="outlined"
          data-test="close-queue-info"
          @click="$emit('close')"
        >
          {{ $t('common.close') }}
        </OrButtonV3>
      </div>
    </template>
  </OrModalV3>
</template>
<script lang="ts">
import { OrButtonV3, OrModalV3 } from '@onereach/ui-components';
import { defineComponent, PropType } from 'vue';
import QueueInfoForm from './QueueInfoForm.vue';
import { QueueAttributes } from '@/types';

export default defineComponent({
  name: 'QueueInfoModal',
  components: {
    OrModalV3,
    OrButtonV3,
    QueueInfoForm,
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
    queueAttributes: {
      type: Object as PropType<QueueAttributes>,
      required: true,
    },
  },
  emits: ['close'],
});
</script>
